import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { StyledSkeleton } from '@omnea-app/frontend/components/layout/skeleton/StyledSkeleton'
import { useShowCardsOnDashboard } from '../../hooks/useShowCardsOnDashboard'
import { NoActiveRfxs } from './NoActiveRfxs'
import { RfxDataGrid } from './RfxDataGrid'
import { RfxMobileCards } from './RfxMobileCards'
import { useGetMyActiveRfxs } from './useGetMyActiveRfxs'
import { RfxRow } from './useRfxColumns'

export const RfxTable = () => {
  const { data: rfxData, isLoading } = useGetMyActiveRfxs()
  const { t } = useTranslation('dashboard')

  const rows: RfxRow[] = (rfxData ?? []).map((rfx) => {
    return {
      id: rfx.requestId,
      requestId: rfx.requestId,
      requestName: rfx.requestName,
      status: rfx.status,
      createdAt: rfx.createdAt,
      dueDate: rfx.dueDate,
    }
  })
  const showCards = useShowCardsOnDashboard()

  return (
    <Stack gap={5} sx={{ width: '100%' }}>
      {isLoading ? (
        <Box sx={{ pb: 2 }}>
          <StyledSkeleton height={28} width={231} />
        </Box>
      ) : (
        <Typography variant="display-h3">{t('rfx-section.title')}</Typography>
      )}
      <Stack width="100%" sx={{ flex: 1 }}>
        {rows.length > 0 && (showCards ? <RfxMobileCards rfxs={rows} /> : <RfxDataGrid rows={rows} />)}
        {rows.length === 0 && !isLoading && <NoActiveRfxs />}
      </Stack>
    </Stack>
  )
}
